import React from 'react'
import {
  ListItem,
  withStyles,
  Grid,
  ListItemSecondaryAction,
} from '@material-ui/core'
import Menu from '../Menu'
import { Person } from '@material-ui/icons'
import { AccountOff } from 'mdi-material-ui'

export default withStyles((theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(16),
    // fontWeight: 'bold',
    display: 'table',
    tableLayout: 'fixed',
    width: '100%',
    whiteSpace: 'nowrap',
    marginTop: 11,
  },
  text: {
    display: 'table-cell',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  secondaryAction: {
    [theme.breakpoints.up('xs')]: {
      paddingRight: 39,
    },
    [theme.breakpoints.up('md')]: {
      paddingRight: 60,
    },
  },
  container: {
    listStyle: 'none',
    borderBottom: '1px solid #adadad',
    borderRight: '1px solid #adadad',
  },
  secondaryActionRoot: {
    [theme.breakpoints.up('xs')]: {
      top: 'calc(50% - 16px)',
    },
    [theme.breakpoints.up('md')]: {
      top: 'calc(50% - 24px)',
    },
  },
  info: {
    display: 'inline-block',
    minHeight: 40,
    marginLeft: /* 75 */ 0,
    // [theme.breakpoints.down('sm')]: {
    //   marginLeft: 68,
    // },
  },
}))(({ classes, addOrEditPush, group, entityType, isPinned }) => {
  const count = group.contact_count || 0
  const Icon = count ? Person : AccountOff

  return (
    <ListItem
      onClick={() => addOrEditPush(group.id)}
      key={`groupsPageListItem${group.id}`}
      button
      classes={{
        container: classes.container,
        secondaryAction: classes.secondaryAction,
      }}
    >
      <Grid container className={classes.info}>
        <Grid item md={12} lg={6}>
          <div className={classes.heading}>
            <span className={classes.text}>
              {isPinned ? '📌 ' : ''}
              {group.name}
            </span>
          </div>
        </Grid>
      </Grid>
      <div
        style={{
          display: 'inline-block',
          fontSize: 14,
          color: '#6b6b6b',
          whiteSpace: 'nowrap',
        }}
      >
        <Icon
          style={{ verticalAlign: 'middle', marginRight: 5, marginBottom: 2 }}
        />
        {`${count} Contact${count === 1 ? '' : 's'}`}
      </div>
      <ListItemSecondaryAction
      // classes={{ root: classes.secondaryActionRoot }}
      >
        <Menu
          vert
          entityName={group.name}
          entityType={entityType}
          entityID={group.id}
          addOrEditPush={addOrEditPush}
        />
      </ListItemSecondaryAction>
    </ListItem>
  )
})
